export const returnAssignmentsWithFilledAssignmentNumberPath = (
  assignments
) => {
  return assignments.map((projectAssignment) => {
    let assignmentNumberPath = [];

    // assignments own number
    assignmentNumberPath.push(projectAssignment.number);

    const returnParentAssignmentNumber = (parentAssignmentId) => {
      const parentAssignment = assignments.find(
        (assignment) => assignment.id === parentAssignmentId
      );
      if (parentAssignment) {
        assignmentNumberPath.push(parentAssignment.number);
        if (parentAssignment.parent) {
          returnParentAssignmentNumber(parentAssignment.parent);
        }
      }
    };

    if (projectAssignment.parent) {
      returnParentAssignmentNumber(projectAssignment.parent);
    }

    return {
      ...projectAssignment,
      assignmentNumberPath: assignmentNumberPath.reverse().join('.'),
    };
  });
};
